<template>    
<div id="AddEquipamento" class="container small">
  <div class="title">
     <h3><router-link class="btn btn-default" :to="{ name: 'ListEquipamento' }"><i class="fa fa-angle-left"></i> Voltar à Lista</router-link>&nbsp;Cadastro de Equipamento</h3>
  </div> 
  <form id="equipamentoForm" v-on:submit.prevent="add">
    <div v-if="error" class="alert alert-danger">
      <span>Campos obrigatórios não preenchidos:</span>
      <ul>
        <li v-bind:key="msg" v-for="msg in msgError">
          {{ msg }}
        </li>
      </ul>
    </div>
    <div class="form-row">
      <div class="form-group col-md-3">
        <label>Tipo de Equipamento</label>
          <v-select reqquired :options="tipo_equipamento" 
                    v-model="newEquipamento.tipo_equipamento" 
                    label="descricao" 
                    value="{ idtipo_equipamento : idtipo_equipamento, descricao : descricao }">
          </v-select>
      </div>
      <div class="form-group col-md-3">
        <label>Data Nota</label>
        <input reqquired type="date" class="form-control form-control" v-model="newEquipamento.data_nota">
      </div>
      <div class="form-group col-md-3">
        <label>Data Entrada</label>
        <input reqquired type="date" class="form-control form-control" v-model="newEquipamento.data_entrada">
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-12">
        <label>Marca\Modelo</label>
        <input reqquired type="text" class="form-control form-control" v-model="newEquipamento.marca_modelo">
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-4">
        <label>IMEI 1</label>
        <input type="text" class="form-control form-control" v-model="newEquipamento.imei1">
      </div>
      <div class="form-group col-md-4">
        <label>IMEI 2</label>
        <input type="text" class="form-control form-control" v-model="newEquipamento.imei2">
      </div>
      <div class="form-group col-md-4">
        <label>Nº Série</label>
        <input type="text" class="form-control form-control" v-model="newEquipamento.num_serie">
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-3">
        <label>Número Nota</label>
        <input type="text" class="form-control form-control" v-model="newEquipamento.num_nota">
      </div>
      <div class="form-group col-md-9">
        <label>Fornecedor</label>
        <input type="text" class="form-control form-control" v-model="newEquipamento.fornecedor">
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-4">
        <label>Valor</label>
        <input type="text" v-model.lazy="price" v-money="money" class="form-control form-control" v-model="newEquipamento.valor">
      </div>
    </div>
    <div class="modal-footer">
      <slot name="footer">
        <button class="btn btn-primary" type="submit">Salvar</button>
        <!--<button class="btn btn-cancel" type="cancel" @click="closeModal($event)">Cancelar</button>--->
      </slot>
    </div>
  </form>
</div>
</template>
<script>

import vSelect from 'vue-select'
const fb = require('../../config/db.js')
import { VMoney } from 'v-money'

export default {
  name: 'AddEquipamento',
  props:["equipamento1"],
  components: {
    vSelect,
  },
  data(){
    return {
      price: 123.45,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: ' #',
        precision: 2,
        masked: false
      },
      directives: { money: VMoney},
      data_atual: new Date().toLocaleString,
      tipo_equipamento: [],
      error: false,
      msgError: [],
      newEquipamento: {
        'tipo_equipamento' : { 'idtipo_equipamento' : "", 'descricao' : '' }, 
        'marca_modelo' : "", 
        'imei1' : "", 
        'imei2' : "", 
        'num_serie' : "",
        'num_nota' : "", 
        'data_nota' : "", 
        'valor' : "", 
        'fornecedor' : "", 
        'data_entrada' : '',  
        'pessoa_id' : '',  
        'data_cadastro' : '', 
        'usuario_cadastro' : '', 
        'data_alteracao' : '', 
        'usuario_alteracao' : '', 
      },
    }
  },
  created() {
   /*if (this.equipamento){
      this.newEquipamento = this.equipamento;
      if (this.equipamento.id)
        this.newEquipamento.id = this.equipamento.id;
    }*/
    if (this.$route.params.equipamento_id)
      this.getEquipamento();
    this.getFormsData();
  },  
  methods: {
    getEquipamento(){
      fb.Equipamento.doc(this.$route.params.equipamento_id).onSnapshot(p => {
        this.newEquipamento = p.data();
        if (this.$route.params.acao == 'editar')
          this.newEquipamento.id = p.id;
      });
    },
    getFormsData(){
      fb.TipoEquipamento.get().then(querySnapshot =>{
        const objects = []
        const objectsArray = []
        let i = 0
        querySnapshot.forEach((doc)=>{
          objectsArray.push(doc.data())
          objectsArray[i].idtipo_equipamento = doc.id
          objects.push(objectsArray[i])
          i++
        });
        this.tipo_equipamento = objects;
      });
    },
    add() {
      this.msgError = [];
      this.error = false;

      if (this.newEquipamento.tipo_equipamento.descricao == ''){
        this.msgError.push('Equipamento');  
        this.error = true;
      }
      if (this.newEquipamento.data_entrada == ''){
        this.msgError.push('Data Entrada');
        this.error = true;
      }
      if (this.newEquipamento.data_nota == ''){
        this.msgError.push('Data Nota');
        this.error = true;
      }
      if (this.newEquipamento.marca_modelo == ''){
        this.msgError.push('Marca/Modelo');
        this.error = true;
      }
      if (this.error)
        return;

      if (this.newEquipamento.id)
        fb.Equipamento.doc(this.newEquipamento.id).update({
          'tipo_equipamento' : { 'idtipo_equipamento' : this.newEquipamento.tipo_equipamento.idtipo_equipamento, 'descricao' : this.newEquipamento.tipo_equipamento.descricao }, 
          'marca_modelo' : this.newEquipamento.marca_modelo, 
          'imei1' : this.newEquipamento.imei1, 
          'imei2' : this.newEquipamento.imei2, 
          'num_serie' : this.newEquipamento.num_serie,
          'num_nota' : this.newEquipamento.num_nota, 
          'data_nota' : this.newEquipamento.data_nota, 
          'valor' : this.newEquipamento.valor, 
          'fornecedor' : this.newEquipamento.fornecedor, 
          'data_entrada' : this.newEquipamento.data_entrada,  
          'pessoa_id': this.newEquipamento.pessoa_id,
          'data_alteracao' : new Date(), 
          'usuario_alteracao' : fb.auth.currentUser.email, 

        });
      else {
        fb.Equipamento.where("del", "==", "n").get().then(querySnapshot =>{
          let i = querySnapshot.size+1;
          let codigo = '';
          if (this.newEquipamento.tipo_equipamento.descricao == 'Impressora Mesa')
            codigo = 'IM'+("0000" + i).slice(-4);
          else if (this.newEquipamento.tipo_equipamento.descricao == 'Desktop')
            codigo = 'DE'+("0000" + i).slice(-4);
          else if (this.newEquipamento.tipo_equipamento.descricao == 'Impressora Portátil')
            codigo = 'IP'+("0000" + i).slice(-4);
          else if (this.newEquipamento.tipo_equipamento.descricao == 'Celular')
            codigo = 'CE'+("0000" + i).slice(-4);
          else if (this.newEquipamento.tipo_equipamento.descricao == 'Diversos')
            codigo = 'DI'+("0000" + i).slice(-4);
          else if (this.newEquipamento.tipo_equipamento.descricao == 'Notebook')
            codigo = 'NT'+("0000" + i).slice(-4);
          fb.Equipamento.add({
            'codigo': codigo,
            'tipo_equipamento' : { 'idtipo_equipamento' : this.newEquipamento.tipo_equipamento.idtipo_equipamento, 'descricao' : this.newEquipamento.tipo_equipamento.descricao }, 
            'marca_modelo' : this.newEquipamento.marca_modelo, 
            'imei1' : this.newEquipamento.imei1, 
            'imei2' : this.newEquipamento.imei2, 
            'num_serie' : this.newEquipamento.num_serie,
            'num_nota' : this.newEquipamento.num_nota, 
            'data_nota' : this.newEquipamento.data_nota, 
            'valor' : this.newEquipamento.valor, 
            'fornecedor' : this.newEquipamento.fornecedor, 
            'data_entrada' : this.newEquipamento.data_entrada,  
            'pessoa_id': null,
            'data_cadastro' : new Date(), 
            'usuario_cadastro' : fb.auth.currentUser.email, 
            'del' : 'n',
            'usuario_del': '',
            'data_del': ''
          });
        });
      }
      this.$emit('list-closeModal');
      this.$router.push({ name : 'ListEquipamento' });
    },
    closeModal(event){
      event.preventDefault();
      this.$emit('list-closeModal');
    }
  },
  firestore: function() {
    
  }
}
</script>
<style scoped>
  .title {
    margin-top: 24px;
    margin-bottom: 32px;
  }
</style>



